import { Fragment } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";
import { FaLaptop, FaServer } from "react-icons/fa";
import { LuBookMarked } from "react-icons/lu";
import { AiOutlineHome, AiOutlineFileSearch } from "react-icons/ai";
import { BsPeople } from "react-icons/bs";
import { MdOndemandVideo, MdOutlinePermContactCalendar } from "react-icons/md";
import "../assets/css/navbar.css";

const navigation = [
  { name: "Inicio", href: "/", current: false, icon: <AiOutlineHome /> },
  { name: "Integrantes", href: "/people", current: false, icon: <BsPeople /> },
  {
    name: "Proyectos",
    href: "/projects",
    current: false,
    icon: <AiOutlineFileSearch />,
  },
  {
    name: "Publicaciones",
    href: "/publications",
    current: false,
    icon: <LuBookMarked />,
  },
  { name: "Software", href: "/software", current: false, icon: <FaLaptop /> },
  {
    name: "Videos",
    href: "/videos",
    current: false,
    icon: <MdOndemandVideo />,
  },
  {
    name: "Infraestructura",
    href: "/infraestructura",
    current: false,
    icon: <FaServer />,
  },
  {
    name: "Contacto",
    href: "/contact",
    current: false,
    icon: <MdOutlinePermContactCalendar />,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const NavbarComp2 = () => {
  const location = useLocation();
  
  return (
    <div className="flex flex-col min-h-screen">
      <Disclosure
        as="nav"
        className="navbar-transparent bg-white"
      >
        {({ open }) => (
          <>
            <Container>
              <div className="relative flex h-16 items-center justify-between">
                <div className="flex flex-1 items-center justify-between sm:items-stretch">
                  <div className="flex flex-shrink-0 items-center">
                    <img
                      className="block h-10 w-auto lg:hidden"
                      src={process.env.PUBLIC_URL + "/Logo_AdaLab.png"}
                      style={{ width: "100px", height: "120px" }}
                      alt="Adalab"
                    />
                    <img
                      as={Link}
                      to={"/"}
                      className="hidden h-10 w-auto lg:block"
                      src={process.env.PUBLIC_URL + "/Logo_AdaLab.png"}
                      style={{
                        width: "100px",
                        height: "120px",
                        overflow: "visible",
                      }}
                      alt="Adalab"
                    />
                  </div>

                  <div className="hidden sm:flex sm:items-center">
                    <div className="flex space-x-2">
                      {navigation.map((item) => {
                        const isActive = location.pathname === item.href || 
                                        (item.href !== '/' && location.pathname.startsWith(item.href));
                        return (
                          <Link
                            key={item.name}
                            to={item.href}
                            className={`rounded-md py-2 px-2.5 text-sm no-underline font-sans transition-colors duration-200 flex items-center`}
                            style={{
                              color: isActive ? "#2196F3" : "black",
                              textDecoration: "none",
                            }}
                          >
                            <span className={`mr-1.5 hover:text-colorPrincipal whitespace-nowrap ${
                              isActive ? 'text-colorPrincipal font-bold' : ''
                            }`}>{item.name}</span>
                            {React.cloneElement(item.icon, {
                              className: `w-4 h-4 hover:text-colorPrincipal ${isActive ? 'text-colorPrincipal' : ''}`,
                            })}
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
                  <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="sr-only">Abrir Menu</span>
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </Container>

            <Disclosure.Panel className="sm:hidden">
              <div className="space-y-1 px-2 pb-3 pt-2">
                {navigation.map((item) => {
                  const isActive = location.pathname === item.href || 
                                  (item.href !== '/' && location.pathname.startsWith(item.href));
                  return (
                    <Disclosure.Button
                      key={item.name}
                      as="a"
                      href={item.href}
                      className={classNames(
                        isActive
                          ? "text-white bg-colorPrincipal font-bold"
                          : "hover:bg-colorPrincipal hover:text-white",
                        "block rounded-md px-3 py-2 text-base font-bold",
                        "no-underline",
                        "transition-colors ease-in-out"
                      )}
                      aria-current={isActive ? "page" : undefined}
                      style={{
                        color: isActive ? "white" : "black",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "white")}
                      onMouseLeave={(e) => (e.target.style.color = isActive ? "white" : "black")}
                    >
                      {item.name}
                    </Disclosure.Button>
                  );
                })}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      <br />
      <br />
      <section className="flex-grow flex flex-col">
        <Outlet />
      </section>
    </div>
  );
};

export default NavbarComp2;
